import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Config from '../../../helpers/Config';
import Seo from '../../components/shared/Seo';
import { setPunchOut } from '../../../stateManagment/features/punchoutSlice';

//-- Thin StartPage landing for PunchOut. Coupa (and other procurement systems) open this
//-- URL in the buyer's browser. It consumes the single-use token via the AdminPanel backend,
//-- which drives SFCC passwordless login, then hands off to the existing /login pipeline
//-- (SP + LoginSessionID) so the SPA logs the buyer in exactly like standard SSO.
const PunchOutSession = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { token } = useParams();
    const [errorMessage, setErrorMessage] = useState('');
    const hasStartedRef = useRef(false);

    useEffect(() => {
        if (hasStartedRef.current) return;
        hasStartedRef.current = true;

        const authenticate = async () => {
            try {
                const baseUrl = Config.ENV_ADMIN_BASE_URL ?? Config.ADMIN_BASE_URL;
                const url = `${baseUrl}api/v1/punchout/session/${encodeURIComponent(token)}/authenticate`;

                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                });

                const result = await response.json().catch(() => null);

                if (!response.ok || !result || result.success !== true) {
                    setErrorMessage('We could not start your PunchOut session. Please return to your procurement system and try again.');
                    return;
                }

                //-- Persist for the non-RTK axios header helper (ApiHelpers/CommonHelper read localStorage).
                if (result.sessionId) {
                    localStorage.setItem('PunchOutSessionId', result.sessionId);
                    localStorage.setItem('PunchOutActive', 'true');
                }

                //-- Mark the SPA as a PunchOut session so the cart shows "Return Cart" instead of Checkout.
                dispatch(setPunchOut({
                    isPunchOut: true,
                    sessionId: result.sessionId,
                    provider: result.providerType,
                    basketId: result.basketId,
                    operation: result.operation
                }));

                //-- Reuse the existing login flow: it polls slas/extauth for SP + LoginSessionID.
                navigate(`/login?SP=${encodeURIComponent(result.sp)}&LoginSessionID=${encodeURIComponent(result.loginSessionID)}`, { replace: true });
            } catch (err) {
                setErrorMessage('We could not start your PunchOut session. Please return to your procurement system and try again.');
            }
        };

        authenticate();
    }, [token, navigate, dispatch]);

    return (
        <>
            <Seo title="PunchOut" description="PunchOut session" keywords="PunchOut" />
            <section className="about-area ptb-60">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12 col-md-12 text-center">
                            {errorMessage
                                ? <p>{errorMessage}</p>
                                : <p>Starting your session, please wait...</p>}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PunchOutSession;
